import taxiIcon from './taxi-icon.svg';
import taxiIconUnion from './taxi-icon-union.svg';
import taxiIconReale from './taxi-icon-reale.svg';
import taxiIconPlusUltra from './taxi-icon-plus-ultra.svg';
import taxiIconMgs from './taxi-icon-mgs.svg';
import taxiIconHelvetia from './taxi-icon-helvetia.svg';
import taxiIconGes from './taxi-icon-ges.svg';
import taxiIconFiatc from './taxi-icon-fiatc.svg';
import taxiIconCatalana from './taxi-icon-catalana.svg';
import taxiIconCaser from './taxi-icon-caser.svg';
import taxiIconBilbao from './taxi-icon-bilbao.svg';
import resumeIcon from './resume.svg';
import phoneIcon from './phone.svg';
import markerIcon from './marker.svg';
import markerIconUnion from './marker-union.svg';
import markerIconReale from './marker-reale.svg';
import markerIconPlusUltra from './marker-plus-ultra.svg';
import markerIconMgs from './marker-mgs.svg';
import markerIconHelvetia from './marker-helvetia.svg';
import markerIconGes from './marker-ges.svg';
import markerIconFiatc from './marker-fiatc.svg';
import markerIconCat from './marker-catalana.svg';
import markerIconCaser from './marker-caser.svg';
import markerIconBilbao from './marker-bilbao.svg';
import locationIcon from './location-icon.svg';
import locationIconUnion from './location-icon-union.svg';
import locationIconReale from './location-icon-reale.svg';
import locationIconPlusUltra from './location-icon-plus-ultra.svg';
import locationIconMgs from './location-icon-mgs.svg';
import locationIconHelvetia from './location-icon-helvetia.svg';
import locationIconGes from './location-icon-ges.svg';
import locationIconFiatc from './location-icon-fiatc.svg';
import locationIconCat from './location-icon-catalana.svg';
import locationIconCaser from './location-icon-caser.svg';
import locationIconBilbao from './location-icon-bilbao.svg';
import flagUKIcon from './flag-uk.svg';
import flagSpainIcon from './flag-spain.svg';
import flagCatIcon from './flag-cat.svg';
import eyeIcon from './eye.svg';
import editIcon from './edit.svg';
import editWhiteIcon from './edit-white.svg';
import deleteIcon from './delete.svg';
import craneIcon from './crane-icon.svg';
import craneIconUnion from './crane-icon-union.svg';
import craneIconReale from './crane-icon-reale.svg';
import craneIconPlusUltra from './crane-icon-plus-ultra.svg';
import craneIconMgs from './crane-icon-mgs.svg';
import craneIconHelvetia from './crane-icon-helvetia.svg';
import craneIconGes from './crane-icon-ges.svg';
import craneIconFiatc from './crane-icon-fiatc.svg';
import craneIconCatalana from './crane-icon-catalana.svg';
import craneIconCaser from './crane-icon-caser.svg';
import craneIconBilbao from './crane-icon-bilbao.svg';
import closeIcon from './close.svg';
import closeIconWhite from './close-white.svg';
import chevronLeftIcon from './chevron-left.svg';
import chatIcon from './chat-white.svg';
import chatIconUnion from './chat-white-u.svg';
import chatIconReale from './chat-white-r.svg';
import chatIconPlusUltra from './chat-white-p.svg';
import chatIconMgs from './chat-white-m.svg';
import chatIconHelvetia from './chat-white-h.svg';
import chatIconGes from './chat-white-g.svg';
import chatIconFiatc from './chat-white-fiatc.svg';
import chatIconCaser from './chat-white-caser.svg';
import chatIconCatalana from './chat-white-c.svg';
import chatIconBilbao from './chat-white-b.svg';
import cancelIcon from './cancel-icon.svg';
import bellIcon from './bell.svg';
import arrowRight from './arrow-right.svg';
import arrowLeftIcon from './arrow-left.svg';
import arrowLeftWhiteIcon from './arrow-left-white.svg';
import addIcon from './add.svg';

export const markerIcons = {
  default: markerIcon,
  '00000016': markerIcon,
  '00000001': markerIconBilbao,
  '00000002': markerIconCat,
  '00000006': markerIconGes,
  '00000007': markerIconUnion,
  '00000010': markerIconMgs,
  '00000011': markerIconHelvetia,
  '00000020': markerIconPlusUltra,
  '00000025': markerIconReale,
  '00000045': markerIconFiatc,
  '00000060': markerIconCaser,
};

export const locationIcons = {
  '00000016': locationIcon,
  '00000001': locationIconBilbao,
  '00000002': locationIconCat,
  '00000006': locationIconGes,
  '00000007': locationIconUnion,
  '00000010': locationIconMgs,
  '00000011': locationIconHelvetia,
  '00000020': locationIconPlusUltra,
  '00000025': locationIconReale,
  '00000045': locationIconFiatc,
  '00000060': locationIconCaser,
};

export const craneIcons = {
  default: craneIcon,
  '00000016': craneIcon,
  '00000001': craneIconBilbao,
  '00000002': craneIconCatalana,
  '00000006': craneIconGes,
  '00000007': craneIconUnion,
  '00000010': craneIconMgs,
  '00000011': craneIconHelvetia,
  '00000020': craneIconPlusUltra,
  '00000025': craneIconReale,
  '00000045': craneIconFiatc,
  '00000060': craneIconCaser,
};

export const taxiIcons = {
  default: taxiIcon,
  '00000016': taxiIcon,
  '00000001': taxiIconBilbao,
  '00000002': taxiIconCatalana,
  '00000006': taxiIconGes,
  '00000007': taxiIconUnion,
  '00000010': taxiIconMgs,
  '00000011': taxiIconHelvetia,
  '00000020': taxiIconPlusUltra,
  '00000025': taxiIconReale,
  '00000045': taxiIconFiatc,
  '00000060': taxiIconCaser,
};

export const chatIcons = {
  '00000016': chatIcon,
  '00000001': chatIconBilbao,
  '00000002': chatIconCatalana,
  '00000006': chatIconGes,
  '00000007': chatIconUnion,
  '00000010': chatIconMgs,
  '00000011': chatIconHelvetia,
  '00000020': chatIconPlusUltra,
  '00000025': chatIconReale,
  '00000045': chatIconFiatc,
  '00000060': chatIconCaser,
};

export const icons = {
  arrowLeftWhiteIcon,
  arrowRight,
  addIcon,
  arrowLeftIcon,
  deleteIcon,
  editIcon,
  closeIcon,
  flagSpainIcon,
  flagUKIcon,
  flagCatIcon,
  resumeIcon,
  chevronLeftIcon,
  eyeIcon,
  markerIconCat,
  markerIconUnion,
  markerIconReale,
  markerIconPlusUltra,
  markerIconMgs,
  markerIconHelvetia,
  markerIconGes,
  markerIconBilbao,
  markerIconCaser,
  markerIcon,
  locationIcon,
  editWhiteIcon,
  chatIcon,
  bellIcon,
  cancelIcon,
  craneIcon,
  closeIconWhite,
  phoneIcon,
  taxiIcon,
};
